<template>
  <v-main>
    <v-container fluid>
      <v-row justify="start">
        <v-col>
          <span class="text-h5 font-weight-bold" v-text="' List of Values'"></span>
          <v-btn class="mx-2 mb-2" :loading="isSaving" :disabled="isSaving" small color="primary" @click="save">
            Save
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-autocomplete @change="getData" ref="value" v-model="value_id" :items="valueItems" label="Select Value"
            prepend-icon="mdi-format-list-text" solo></v-autocomplete>
        </v-col>
      </v-row>
      <v-progress-linear v-if="isLoading" indeterminate color="primary"></v-progress-linear>
      <v-row v-else>
        <v-col md="12" v-if="value_id">
          <v-card elevation="6">
            <v-simple-table fixed-header :height="`${valueLists.length ? '370px' : ''}`">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Description</th>
                    <th class="text-left">Code</th>
                    <th class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(valueList, i) in valueLists" :key="`valueList${i}`">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <v-col class="px-0">
                        <v-text-field v-model="valueList.description" outlined dense label="Description" :input="(valueList.description =
                          (valueList.description || '').toUpperCase())
                          " hide-details="auto" :error-messages="!valueList.description
    ? 'this description field is required'
    : ''
    "></v-text-field>
                      </v-col>
                    </td>
                    <td>
                      <v-col class="px-0">
                        <v-text-field :error-messages="!valueList.code
                          ? 'this code field is required'
                          : ''
                          " v-model="valueList.code" :input="(valueList.code = (valueList.code || '').toUpperCase())
    " outlined dense label="Code" hide-details="auto"></v-text-field>
                      </v-col>
                    </td>

                    <td class="text-right">
                      <div class="text-center">
                        <v-tooltip bottom v-if="!valueList.id">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small color="primary" icon
                              @click="deleteValueList(valueList)">
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                        <v-tooltip bottom v-else>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" small color="primary" icon @click="delete_data(valueList.id)">
                              <v-icon>mdi-delete-outline</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="value_id">
                    <td colspan="4">
                      <v-btn outlined block color="primary" @click="addEmptyValueList()">
                        Add New Row
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "ValueListsPage",
  data() {
    return {
      value_id: "",
      valueItems: [],
      valueLists: [],
      excel_fields: {
        "Sr No": "sr_no",
        DESCRIPTION: "description",
        CODE: "code",
      },
      title: "",
      value_list_excel: [],
      isLoading: false,
      isSaving: false,
      valueListLoader: null,
      isOfflineMode: window && window.electron,
    };
  },

  watch: {
    // Watch for changes to value_id and load corresponding ValueLists
    value_id: {
      handler: function(newValueId, oldValueId) {
        console.log('value_id changed:', oldValueId, '->', newValueId);
        if (newValueId && newValueId !== oldValueId) {
          this.getData();
        } else if (!newValueId) {
          // Clear list if no value selected
          this.valueLists = [];
        }
      },
      immediate: false // Don't trigger on initial component creation
    }
  },

  async mounted() {
    await this.initializeValueListLoader();
    await this.getMasters();
  },
  methods: {
    async initializeValueListLoader() {
      try {
        const { valueListLoader } = await import('@/services/valuelist-loader');
        this.valueListLoader = valueListLoader;
        console.log('ValueList loader initialized');
      } catch (error) {
        console.error('Failed to initialize ValueList loader:', error);
      }
    },
    
    async getMasters() {
      try {
        this.valueItems = [];
        
        if (this.valueListLoader) {
          // Use the new ValueList loader
          this.valueItems = await this.valueListLoader.getAllValues();
          console.log('Value items loaded:', this.valueItems.length);
        } else {
          // Fallback to direct API call if loader not available
          let response = await axios.get("value_lists/showAll");
          let rawData = response.data?.data || [];

          // Group data by category (value_id)
          let masters = {
            vessels: rawData.filter(item => item.value_id === 6),
            ranks: rawData.filter(item => item.value_id === 1),
            subjects: rawData.filter(item => item.value_id === 3),
            duration: rawData.filter(item => item.value_id === 2),
            nationality: rawData.filter(item => item.value_id === 4),
            birth_place: rawData.filter(item => item.value_id === 5),
          };
          
          // Defensive coding with null checks
          if (masters.values && Array.isArray(masters.values)) {
            masters.values.forEach((value) => {
              if (value && value.id && value.name) {
                this.valueItems.push({
                  id: value.id,
                  text: value.name,
                  value: value.id,
                });
              }
            });
          }
          
          console.log('Value items loaded from API fallback:', this.valueItems.length);
        }
      } catch (error) {
        console.error('Error loading Values:', error);
        this.valueItems = [];
      }
    },
    async getData() {
      // Guard clause: don't load if no value is selected
      if (!this.value_id) {
        this.valueLists = [];
        console.log('getData: No value_id selected, clearing list');
        return;
      }
      
      try {
        this.isLoading = true;
        console.log('getData: Loading ValueLists for value_id:', this.value_id, '(type:', typeof this.value_id, ')');
        
        if (this.valueListLoader) {
          // Use the new ValueList loader (handles offline/online automatically)
          this.valueLists = await this.valueListLoader.getValueListsForValue(this.value_id);
          console.log('getData: ValueLists loaded via loader:', this.valueLists.length);
        } else {
          // Fallback to direct API call if loader not available
          console.log('getData: Loader not available, using direct API call');
          let response = await axios.get(`/values/${this.value_id}/value_lists`);
          this.valueLists = response.data?.data || [];
          console.log('getData: ValueLists loaded via API fallback:', this.valueLists.length);
        }
        
      } catch (error) {
        console.error('getData: Error loading ValueLists:', error);
        this.valueLists = [];
        
        // User feedback
        if (this.$toast) {
          this.$toast.error('Failed to load ValueList items');
        }
      } finally {
        this.isLoading = false;
      }
    },
    searchData() {
      this.getData();
    },
    deleteValueList(valueList) {
      const index = this.valueLists.indexOf(valueList);
      if (index > -1) {
        this.valueLists.splice(index, 1);
      }
    },
    addEmptyValueList() {
      this.valueLists.push({
        value_id: this.value_id,
        company_id: this.company.id,
        description: "",
        code: "",
        is_active: 1,
      });
    },
    async save() {
      if (this.valueLists.length === 0) {
        console.log('No ValueLists to save');
        return;
      }
      
      // Validate required fields
      const hasInvalidItems = this.valueLists.some(vl => !vl.description || !vl.code);
      if (hasInvalidItems) {
        if (this.$toast) {
          this.$toast.error('Please fill all required fields (Description and Code)');
        } else {
          alert('Please fill all required fields (Description and Code)');
        }
        return;
      }
      
      try {
        this.isSaving = true;
        
        let payload = {
          datas: this.valueLists,
        };

        let response = await axios.post(
          `/values/${this.value_id}/value_lists_multiple`,
          payload
        );
        
        this.valueLists = response.data.data || [];
        
        // Clear API cache to ensure fresh data on next load
        if (this.valueListLoader) {
          try {
            this.valueListLoader.clearCache();
          } catch (cacheError) {
            console.warn('Failed to clear cache after save:', cacheError);
          }
        }
        
        console.log('ValueLists saved successfully');
        if (this.$toast) {
          this.$toast.success('ValueLists saved successfully');
        }
        
      } catch (error) {
        console.error('Error saving ValueLists:', error);
        if (this.$toast) {
          this.$toast.error('Failed to save ValueLists: ' + (error.response?.data?.message || error.message));
        } else {
          alert('Failed to save ValueLists: ' + (error.response?.data?.message || error.message));
        }
      } finally {
        this.isSaving = false;
      }
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete this item?");
      if (!check) return;
      
      try {
        this.isLoading = true;
        await axios.delete(`value_lists/${id}`);
        
        // Refresh data after successful delete
        await this.getData();
        
        console.log('ValueList item deleted successfully');
        if (this.$toast) {
          this.$toast.success('Item deleted successfully');
        }
        
      } catch (error) {
        console.error('Error deleting ValueList item:', error);
        if (this.$toast) {
          this.$toast.error('Failed to delete item: ' + (error.response?.data?.message || error.message));
        } else {
          alert('Failed to delete item: ' + (error.response?.data?.message || error.message));
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
